export default __webpack_public_path__ + "690dff61f89f30471a564444189a36ed.png";